


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Product, Company } from '@/store/modules/lib';
import { ServerPicture } from '@/utils/ServerPicture'

@Component
export default class ProductMainInfo extends Vue {

  @Prop({ type: Object, default: null }) protected product!: Product;
  @Prop({ type: Array, default: () => [] }) protected standCompanies!: Company[];
  @Prop({ type: Object }) protected fileSetting!: any

  protected pictureLink : any = { backgroundImage: 'url(/product-nophoto-icon.svg)' }

  protected get standTitle() {

    if (this.product != null && this.product._company != '') {
      let companies = this.standCompanies.filter((company: Company) => company._id == this.product._company);
      return companies.length > 0 ? companies[0].standTitle : '';
    }

    return '';

  }

  // protected picture : any = {
  //   isShow: false,
  //   url: ''
  // }

  // @Watch('product')
  // showPicture() {
  //   if(this.product.photo != '') {
  //     ServerPicture.getPictureByKeys([this.product.photo])
  //     .then(res => {
  //       this.picture.isShow = true
  //       this.picture.url = res.data[this.product.photo]
  //     })
  //   } else {
  //     this.picture = {
  //       isShow: false,
  //       url: ''
  //     }
  //   }

  // }

}

